import { Component, ElementRef, OnInit, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
declare var require: any;
import * as Globals from '../globals';
import * as IDMap from '../idmap';
import { Http, Response } from '@angular/http';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import { SimpleTimer } from 'ng2-simple-timer';
import * as Highstocks from 'highcharts/highstock';
import * as Highcharts from 'highcharts';
import * as Highmaps from 'highcharts/highmaps'
//const Highcharts = require('highcharts');
// const Highmaps = require('highcharts/highmaps.src');
import 'highcharts/adapters/standalone-framework.src';
import { max } from 'rxjs/operator/max';
import { ToastsManager } from 'ng2-toastr';

// import 'highcharts/modules/map.src';
// import 'js/highcharts/highcharts-more.src.js';

declare var $: any;
@Component({
  selector: 'app-dashboard-online',
  templateUrl: './dashboard-online.component.html',
  styleUrls: ['./dashboard-online.component.css']
})
export class DashboardOnlineComponent implements OnInit {

  @ViewChild('chart') public chartEl: ElementRef;
  @ViewChild('piechart') public piechartEl: ElementRef;
  @ViewChild('piechartredeem') public piechartredeemEl: ElementRef;
  @ViewChild('charts') public chartsEl: ElementRef;
  @ViewChild('chartsredeem') public chartsredeemEl: ElementRef;
  @ViewChild('linechart') public linechartEl: ElementRef;
  @ViewChild('linechartredeem') public linechartredeemEl: ElementRef;
  @ViewChild('chartsusia') public chartsusiaEl: ElementRef;
  @ViewChild("container", { read: ElementRef }) container: ElementRef;
  @ViewChild('bAgent1') public bAgentEl1: ElementRef;
  @ViewChild('maps') public mapsEl: ElementRef;
  dailyBids: any[];
  agentBids: any[];
  bestAgent: any[];
  tab: number;
  tab_a: number;
  tab_b: number;
  amtVer: number = 0;
  amtCom: number = 0;
  amtUnp: number = 0;
  amtAll: number = 0;
  amt_bid: number = 0;
  bamtAll: number = 0;
  bcominv: number = 0;
  breginv: number = 0;
  lblAmtVer: string = '0';
  lblAmtCom: string = '0';
  lblAmtUnp: string = '0';
  lbltotal: string = '0'
  target: string = '0';
  minbid: string = '0';
  maxbid: string = '0';
  kuota: string = '0';
  kuotaredeem: string = '0';
  sisakuotaredeem: string = '0';
  confirmredeem: string = '0';
  nomperunit: string = '0';
  tglbuka: Date;
  tgltutup: Date;
  tglsettle: string = '0';
  tglmaturity: string = '0';
  completedbar: string = '0%';
  verifiedbar: string = '0%';
  xDailyBids: any[];
  xagentBids: any[];
  openclose: string;
  xamtVer: any[];
  xamtCom: any[];
  xamtUnp: any[];
  xamtBid: any[];
  dataDailyBidsV: any[];
  dataDailyBidsC: any[];
  dataDailyBidsU: any[];
  dataDailyBidsConfirm: any[];
  dataBAgentbids1: any[];
  dataBAgentbids2: any[];
  xdataBAgentbids: any[];
  dataMap: any[];
  dataRegion: any[];
  profesi: any[];
  sortAsc: boolean = false;
  p: number = 1;
  p2: number = 1;
  p3: number = 1;
  colSort: string[] = ['COMPLETED_INVESTOR'];
  colSort2: string[] = ['AMT_COM'];
  colsort3: string[] = ['AMT_BID'];
  col: number = 1;
  col2: number = 2;
  userProfile: any;
  loading: boolean;
  series: any[];
  aucId: any;
  selectedSeries: any;
  selectedAucType: any;
  selectedAucName: any;
  auctionTypes: any[];
  idx: number = 0;
  reverse: boolean = true;
  reverse2: boolean = true;
  selectedBAgent: number = 1;
  xaxis: number = 1;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private st: SimpleTimer) {
    this.userProfile = { MAIN_MENU: [], CONTROL_PANEL: [], FULLNAME: '' };
    this.tab = 1;
    this.tab_a = 101;
    this.tab_b = 201;
    this.toastr.setRootViewContainerRef(vRef);
    this.auctionTypes = [{ aucType: 1, name: 'Penerbitan' }, { aucType: 2, name: 'Redemption' }];
    this.st.newTimer('1min', 1000);
    this.st.subscribe('1min', () => this.refreshdashboard());
  }
  private _chart: any;
  private _piechart: any;
  private _charts: any;
  private _linechart: any;
  private _bAgent1: any;
  ngOnInit() {
    this.refreshdashboard();
  }
  refreshdashboard() {
    this.series = [];
    this.dailyBids = [];
    this.xDailyBids = [];
    this.xagentBids = [];
    this.xamtVer = [];
    this.xamtCom = [];
    this.xamtUnp = [];
    this.dataDailyBidsV = [];
    this.dataDailyBidsC = [];
    this.dataDailyBidsConfirm = [];
    this.dataDailyBidsU = [];
    this.dataRegion = [];
    this.agentBids = [];
    this.bestAgent = [];
    this.aucId = [];
    this.dataBAgentbids1 = [];
    this.dataBAgentbids2 = [];
    this.xdataBAgentbids = [];
    this.dataRegion = [{ hc_key: '1', name: 'DKI Jakarta', value: 0, pcent: '0%' }, { hc_key: '2', name: 'Indonesia Barat (selain DKI Jakarta)', value: 0, pcent: '0%' }, { hc_key: '3', name: 'Indonesia Tengah', value: 0, pcent: '0%' }, { hc_key: '4', name: 'Indonesia Timur', value: 0, pcent: '0%' }];
    this.selectedSeries = { SERIES_ID: 0, SERIES_NAME: '' };
    this.selectedAucType = this.auctionTypes[0];
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      this.getAuction();
      // this.getSeries();
    }
  }
  ngOnDestroy() {
    //if (this.series.length > 0) {
    //    this._chart.destroy();
    //    this._piechart.destroy();
    //}
  }
  setAucType() {
    if (this.selectedAucType.aucType == 2) {
      this.selectedAucType = this.auctionTypes[0];
      this.selectedAucType.aucType == '1';
      // this.getSeries();
    } else {
      this.selectedAucType = this.auctionTypes[1];
      this.selectedAucType.aucType == '2';
    }
    this.getSeries();
    this.loading = true;
    this.getMapData();
    this.setLblAmt();
  }
  setChartsUsia() {
    let opts: any = {
      title: {
        text: '',
        x: -20
      },
      colors: Highcharts.map(Highcharts.getOptions().colors, function (color) {
        return {
          radialGradient: {
            cx: 0.5,
            cy: 0.3,
            r: 0.7
          },
          stops: [
            [0, color],
            [1, Highcharts.Color(color).brighten(-0.3).get('rgb')] // darken
          ]
        };
      }),
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
            style: {
              color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
            },
            connectorColor: 'silver'
          }
        }
      },
      series: [{
        name: 'Share',
        data: [
          { name: 'Chrome', y: 61.41 },
          { name: 'Internet Explorer', y: 11.84 },
          { name: 'Firefox', y: 10.85 },
          { name: 'Edge', y: 4.67 },
          { name: 'Safari', y: 4.18 },
          { name: 'Other', y: 7.05 }
        ]
      }],
    };

    if (this.chartsusiaEl && this.chartsusiaEl.nativeElement) {
      opts.chart = {
        renderTo: this.chartsusiaEl.nativeElement,
        backgroundColor: 'rgba(0,0,0,0)',
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      };

      this._chart = new Highcharts.Chart(opts);
    }
  }


  setCharts() {
    let opts: any = {
      chart: {
        type: 'bar',
      },
      title: {
        text: '',
        x: -20
      },
      xAxis: {
        categories: this.xagentBids,
        title: {
          text: null
        },
        scrollbar: {
          enabled: true
        },
        // type: 'category',
        min: 0,
        max: this.xagentBids.length - 1,
        // scrollbar: {
        //     enabled: true
        // },
        // tickLength: 0


      },
      yAxis: {
        min: 0,
        title: {
          text: 'Pemesanan (juta)',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        }
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true
          },
          enableMouseTracking: false
        },
        series: {
          stacking: 'normal',
        }
      },
      credits: { enabled: false },
      series: [{
        name: 'Unpaid',
        data: this.xamtUnp,
        color: 'rgba(179, 45, 0, 0.7)'
      },
      {
        name: 'Waiting',
        data: this.xamtVer,
        color: 'rgba(230, 115, 0, 0.7)'
      },
      {
        name: 'Completed',
        data: this.xamtCom,
        color: 'rgba(0, 64, 128, 0.7)'
      }]
    };

    if (this.chartsEl && this.chartsEl.nativeElement) {
      opts.chart = {
        type: 'bar',
        renderTo: this.chartsEl.nativeElement,
        backgroundColor: 'rgba(0,0,0,0)',
      };

      this._chart = new Highstocks.Chart(opts);
    }
  }
  setChartsRedeem() {
    let opts: any = {
      chart: {
        type: 'bar',
      },
      title: {
        text: '',
        x: -20
      },
      xAxis: {
        categories: this.xagentBids,
        title: {
          text: null
        },
        scrollbar: {
          enabled: true
        },
        // type: 'category',
        min: 0,
        max: this.xagentBids.length - 1,
        // scrollbar: {
        //     enabled: true
        // },
        // tickLength: 0


      },
      yAxis: {
        min: 0,
        title: {
          text: 'Redeem (juta)',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        }
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true
          },
          enableMouseTracking: false
        },
        series: {
          stacking: 'normal',
        }
      },
      credits: { enabled: false },
      series: [
        {
          name: 'Confirmed',
          data: this.xamtBid,
          color: 'rgba(0, 64, 128, 0.7)'
        }]
    };

    if (this.chartsredeemEl && this.chartsredeemEl.nativeElement) {
      opts.chart = {
        type: 'bar',
        renderTo: this.chartsredeemEl.nativeElement,
        backgroundColor: 'rgba(0,0,0,0)',
      };

      this._chart = new Highstocks.Chart(opts);
    }
  }

  setLineChart() {
    let opts: any = {
      chart: {
        type: 'areaspline'
      },
      title: {
        text: '',
        x: -20
      },
      xAxis: {
        categories: this.xDailyBids,
        scrollbar: {
          enabled: true
        },
        min: 0,
        max: this.xaxis,
        tickLength: 0
      },
      yAxis: {
        title: {
          text: 'Pemesanan (juta)'
        },
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true
          },
          enableMouseTracking: false
        },
        fillOpacity: 0.005,
        series: {
          stacking: 'normal',
        }
      },
      credits: { enabled: false },
      series: [{
        name: 'Unpaid',
        data: this.dataDailyBidsU,
        color: 'rgba(179, 45, 0, 1)'
      },
      {
        name: 'Waiting',
        data: this.dataDailyBidsV,
        color: '#e67300'
      }, {
        name: 'Completed',
        data: this.dataDailyBidsC,
        color: '#004080'
      }
      ]
    };

    if (this.linechartEl && this.linechartEl.nativeElement) {
      opts.chart = {
        type: 'areaspline',
        renderTo: this.linechartEl.nativeElement,
        backgroundColor: 'rgba(0,0,0,0)',
      };
      this._chart = new Highstocks.Chart(opts);
    }
  }
  setLineChartRedeem() {
    let opts: any = {
      chart: {
        type: 'areaspline'
      },
      title: {
        text: '',
        x: -20
      },
      xAxis: {
        categories: this.xDailyBids,
        scrollbar: {
          enabled: true
        },
        min: 0,
        max: this.xaxis,
        tickLength: 0
      },
      yAxis: {
        title: {
          text: 'Redeem (juta)'
        },
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true
          },
          enableMouseTracking: false
        },
        fillOpacity: 0.005,
        series: {
          stacking: 'normal',
        }
      },
      credits: { enabled: false },
      series: [{
        name: 'Confirmed',
        data: this.dataDailyBidsConfirm,
        color: '#004080'
      }
      ]
    };

    if (this.linechartredeemEl && this.linechartredeemEl.nativeElement) {
      opts.chart = {
        type: 'areaspline',
        renderTo: this.linechartredeemEl.nativeElement,
        backgroundColor: 'rgba(0,0,0,0)',
      };
      this._chart = new Highstocks.Chart(opts);
    }
  }

  setPieChart() {
    let opts: any = {
      title: {
        text: 'Pemesanan per Profesi'
      },
      // colors: ['#4472c4', '#757575', '#89A54E', '#80699B', '#3D96AE', '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92', '#666633'],
      colors: ['rgba(179, 45, 0, 0.7)',
        'rgba(230, 115, 0, 0.7)',
        'rgba(230, 165, 0, 0.7)',
        'rgba(0, 64, 128, 0.7)',
        'rgba(0, 129, 190, 0.7)',
        'rgba(0, 180, 230, 0.7)',
        'rgba(0, 128, 43, 0.7)',
        'rgba(119, 186, 61, 0.7)',
        'rgba(192, 230, 78, 0.7)',
        'rgba(173, 2, 105, 0.7)'],
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      },
      credits: { enabled: false },
      legend: {
        layout: 'vertical',
        align: 'left',
        x: 0,
        verticalAlign: 'bottom',
        floating: true
      },

      series: [{
        name: 'Pekerjaan',
        colorByPoint: true,
        data: this.profesi
      }]
    }
    if (this.piechartEl && this.piechartEl.nativeElement) {
      opts.chart = {
        plotBackgroundColor: null,
        backgroundColor: 'rgba(0,0,0,0)',
        plotBorderWidth: null,
        plotShadow: false,
        renderTo: this.piechartEl.nativeElement,
        type: 'pie'
      };

      this._piechart = new Highcharts.Chart(opts);
    }
  }
  setPieChartRedeem() {
    let opts: any = {
      title: {
        text: 'Redeem per Profesi'
      },
      // colors: ['#4472c4', '#757575', '#89A54E', '#80699B', '#3D96AE', '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92', '#666633'],
      colors: ['rgba(179, 45, 0, 0.7)',
        'rgba(230, 115, 0, 0.7)',
        'rgba(230, 165, 0, 0.7)',
        'rgba(0, 64, 128, 0.7)',
        'rgba(0, 129, 190, 0.7)',
        'rgba(0, 180, 230, 0.7)',
        'rgba(0, 128, 43, 0.7)',
        'rgba(119, 186, 61, 0.7)',
        'rgba(192, 230, 78, 0.7)',
        'rgba(173, 2, 105, 0.7)'],
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      },
      credits: { enabled: false },
      legend: {
        layout: 'vertical',
        align: 'left',
        x: 0,
        verticalAlign: 'bottom',
        floating: true
      },

      series: [{
        name: 'Pekerjaan',
        colorByPoint: true,
        data: this.profesi
      }]
    }
    if (this.piechartredeemEl && this.piechartredeemEl.nativeElement) {
      opts.chart = {
        plotBackgroundColor: null,
        backgroundColor: 'rgba(0,0,0,0)',
        plotBorderWidth: null,
        plotShadow: false,
        renderTo: this.piechartredeemEl.nativeElement,
        type: 'pie'
      };

      this._piechart = new Highcharts.Chart(opts);
    }
  }
  getDailyBids() {
    this.http.get(Globals.serviceUrl + 'ritel/dashDailyBidsOnline?seriesId=' + this.selectedSeries.SERIES_ID + '&aucType=' + this.selectedAucType.aucType + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.dailyBids = res.json();
        this.xDailyBids = [];
        this.dataDailyBidsV = [];
        this.dataDailyBidsC = [];
        this.dataDailyBidsU = [];
        this.dataDailyBidsConfirm = [];
        var progress: number = 0;
        for (var i = 0; i < this.dailyBids.length; i++) {
          if (this.dailyBids[i].AMT_WAIT == null) {
            this.dailyBids[i].AMT_WAIT = 0;
          }
          if (this.dailyBids[i].AMT_CON == null) {
            this.dailyBids[i].AMT_CON = 0;
          }
          if (this.dailyBids[i].AMT_UNP == null) {
            this.dailyBids[i].AMT_UNP = 0;
          }
          if (this.dailyBids[i].AMT == null) {
            this.dailyBids[i].AMT = 0;
          }
          this.dailyBids[i].BID_DATE = this.headerService.getFormatLocalDate(this.dailyBids[i].BID_DATE);
          this.dailyBids[i].TES = this.headerService.getFormatLocalDate(this.dailyBids[i].BID_DATE);
          if (this.dailyBids[i].AMT_VER + this.dailyBids[i].AMT_CON + this.dailyBids[i].AMT_UNP > 0) {
            //progress += this.dailyBids[i].AMT / 1000000;
            this.dataDailyBidsV.push(this.dailyBids[i].AMT_WAIT / 1000000);
            this.dataDailyBidsC.push(this.dailyBids[i].AMT_CON / 1000000);
            this.dataDailyBidsU.push(this.dailyBids[i].AMT_UNP / 1000000);
          }
          if (this.dailyBids[i].AMT > 0) {
            this.dataDailyBidsConfirm.push(this.dailyBids[i].AMT / 1000000)
          }
          this.xDailyBids.push(this.dailyBids[i].BID_DATE_NAME);
        }
        if ((this.dailyBids.length - 1) >= 14) {
          this.xaxis = 14;
        }
        else {
          this.xaxis = this.dailyBids.length - 1;
        }
        if (this.series.length > 0) {
          //this.setChart();
          if (this.selectedAucType.aucType == 1) {
            this.setCharts();
          }
          // else{
          //   this.setChartsRedeem();
          // }
          this.setLineChart();
          this.getProfesiBids();
          this.setChartsUsia();
          this.setLineChartRedeem();
        }
        if (!this.userProfile.PA_ID) {
          this.getAgentBids();
          this.getBestAgent();
        }

      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getAgentBids() {
    this.http.get(Globals.serviceUrl + 'ritel/dashAgentBidsOnline?seriesId=' + this.selectedSeries.SERIES_ID + '&aucType=' + this.selectedAucType.aucType + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.amtVer = 0;
        this.amtCom = 0;
        this.amtUnp = 0;
        this.amt_bid = 0;
        this.amtAll = 0;
        this.agentBids = res.json();
        this.xagentBids = [];
        this.xamtVer = [];
        this.xamtCom = [];
        this.xamtUnp = [];
        this.xamtBid = [];
        for (var i = 0; i < this.agentBids.length; i++) {
          if (this.agentBids[i].AMT_VER > 0) {
            this.amtVer += this.agentBids[i].AMT_VER;
          }
          if (this.agentBids[i].AMT_COM > 0) {
            this.amtCom += this.agentBids[i].AMT_COM;
          }
          if (this.agentBids[i].AMT_UNP > 0) {
            this.amtUnp += this.agentBids[i].AMT_UNP;
          }
          if (this.agentBids[i].AMT_TOTAL > 0) {
            this.amtAll += this.agentBids[i].AMT_TOTAL
          }
          if (this.agentBids[i].AMT_BID > 0) {
            this.amt_bid += this.agentBids[i].AMT_BID
          }
          this.xagentBids.push(this.agentBids[i].AGENT_NAME);
          this.xamtVer.push(this.agentBids[i].AMT_VER / 1000000);
          this.xamtCom.push(this.agentBids[i].AMT_COM / 1000000);
          this.xamtUnp.push(this.agentBids[i].AMT_UNP / 1000000);
          this.xamtBid.push(this.agentBids[i].AMT_BID / 1000000);
        }
        if (this.selectedAucType.aucType == 1) {
          this.setCharts();
        }
        else {
          this.setChartsRedeem();
        }
        // this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  bAgentChange(val: number) {
    this.selectedBAgent = val;
    this.getBestAgent();
  }
  getBestAgent() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/dashbestagent' + this.selectedBAgent + '?seriesid=' + this.selectedSeries.SERIES_ID + '&aucType=' + this.selectedAucType.aucType + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        // this.amtVer = 0;
        this.bcominv = 0;
        this.breginv = 0;
        this.bamtAll = 0;
        this.dataBAgentbids1 = [];
        this.dataBAgentbids2 = [];
        this.xdataBAgentbids = [];
        this.bestAgent = res.json();
        for (var i = 0; i < this.bestAgent.length; i++) {
          this.xdataBAgentbids.push(this.bestAgent[i].AGENT_NAME)
          if (this.selectedBAgent == 1) {
            this.dataBAgentbids1.push(this.bestAgent[i].AMT_TOTAL / 1000000)
          }
          if (this.selectedBAgent == 2) {
            this.dataBAgentbids1.push(this.bestAgent[i].COMPLETED_INVESTOR)
          }
          if (this.selectedBAgent == 2) {
            this.dataBAgentbids2.push(this.bestAgent[i].REGISTERED_INVESTOR)
          }
          if (this.selectedBAgent == 3) {
            this.dataBAgentbids1.push(this.bestAgent[i].TOTAL_CITY)
          }
          if (this.bestAgent[i].COMPLETED_INVESTOR > 0) {
            this.bcominv += this.bestAgent[i].COMPLETED_INVESTOR;
          }
          if (this.bestAgent[i].REGISTERED_INVESTOR > 0) {
            this.breginv += this.bestAgent[i].REGISTERED_INVESTOR;
          }
          if (this.bestAgent[i].AMT_TOTAL > 0) {
            this.bamtAll += this.bestAgent[i].AMT_TOTAL;
          }
        }
        this.setBAgentChart1();
        if (this.selectedAucType.aucType == 1) {
          this.setCharts();
        }
        else {
          this.setChartsRedeem();
        }

        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  setBAgentChart1() {
    let opts1: any = {
      title: {
        text: ''
      },
      xAxis: {
        categories: this.xdataBAgentbids,
        crosshair: true,
        // labels: { enabled: false }
        title: {
          text: null
        },
        scrollbar: {
          enabled: true
        },
        min: 0,
        max: this.xdataBAgentbids.length - 1,
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Pemesanan (juta)',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        }
      },
      // tooltip: {
      //   headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      //   pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      //     '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
      //   footerFormat: '</table>',
      //   shared: true,
      //   useHTML: true
      // },
      credits: { enabled: false },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true
          },
          enableMouseTracking: false
        },
        series: {
          stacking: 'normal',
        }
      },
      series: [{
        name: 'Completed',
        data: this.dataBAgentbids1,
        color: 'rgba(0, 64, 128, 0.7)'
      }
      ]
    };
    let opts2: any = {
      title: {
        text: ''
      },
      xAxis: {
        categories: this.xdataBAgentbids,
        crosshair: true,
        // labels: { enabled: false }
        title: {
          text: null
        },
        scrollbar: {
          enabled: true
        },
        min: 0,
        max: this.xdataBAgentbids.length - 1,
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Jumlah Investor',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        }
      },
      credits: { enabled: false },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true
          },
          enableMouseTracking: false
        },
        series: {
          // stacking: 'normal',
        }
      },
      series: [{
        name: 'Completed Investor',
        data: this.dataBAgentbids1,
        color: '#007399'
      },
      {
        name: 'Registered Investor',
        data: this.dataBAgentbids2,
        color: '#28C14C'
      }
      ]
    };
    let opts3: any = {
      title: {
        text: ''
      },
      xAxis: {
        categories: this.xdataBAgentbids,
        crosshair: true,
        // labels: { enabled: false }
        title: {
          text: null
        },
        scrollbar: {
          enabled: true
        },
        min: 0,
        max: this.xdataBAgentbids.length - 1,
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Jumlah Kota',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        }
      },
      credits: { enabled: false },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true
          },
          enableMouseTracking: false
        },
        series: {
          stacking: 'normal',
        }
      },
      series: [{
        name: 'Jumlah Kota',
        data: this.dataBAgentbids1,
        color: '#28C14C'
      }
      ]
    };

    if (this.bAgentEl1 && this.bAgentEl1.nativeElement) {
      if (this.selectedBAgent == 1) {
        opts1.chart = {
          type: 'bar',
          renderTo: this.bAgentEl1.nativeElement,
          backgroundColor: 'rgba(0,0,0,0)'
        };
        this._chart = new Highstocks.Chart(opts1);
      }
      if (this.selectedBAgent == 2) {
        opts2.chart = {
          type: 'bar',
          renderTo: this.bAgentEl1.nativeElement,
          backgroundColor: 'rgba(0,0,0,0)'
        };
        this._chart = new Highstocks.Chart(opts2);
      }
      if (this.selectedBAgent == 3) {
        opts3.chart = {
          type: 'bar',
          renderTo: this.bAgentEl1.nativeElement,
          backgroundColor: 'rgba(0,0,0,0)'
        };
        this._chart = new Highstocks.Chart(opts3);
      }


    }
  }
  getProfesiBids() {
    this.http.get(Globals.serviceUrl + 'ritel/dashprofesionline?seriesId=' + this.selectedSeries.SERIES_ID + '&aucType=' + this.selectedAucType.aucType + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.profesi = [];
        var data = res.json();
        for (var i = 0; i < data.length; i++) {
          if (i == 1) {
            this.profesi.push({ name: data[i].PROFESI_NAME, y: data[i].AMT, sliced: true, selected: true });
          } else {
            this.profesi.push({ name: data[i].PROFESI_NAME, y: data[i].AMT });
          }

        }
        this.setPieChart();
        this.setPieChartRedeem();
        this.getRegionData();
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getAuction() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/aucId?&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.aucId = res.json();
        if (this.aucId.length > 0) {
          this.selectedAucName = this.aucId[0].AUCTION_NAME;
          this.selectedAucType.aucType = this.aucId[0].CD_AUCTION_TYPE;
          this.getSeries();
        }
        else {
          this.loading = false;
        }
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getSeries() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/dashSeriesOnline?aucType=' + this.selectedAucType.aucType + '&aucName=' + this.selectedAucName + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.series = res.json();
        if (this.series.length > 0) {
          this.selectedSeries = this.series[0];
          console.log(this.selectedSeries);
          this.idx = 0;
          this.getMapData();
          this.setLblAmt();
          var a = new Date(this.selectedSeries.AUCT_OPEN);
          var openlocalOffset = a.getTimezoneOffset() * 60000;
          var openlocalTime = a.getTime() + openlocalOffset;
          var b = new Date(this.selectedSeries.AUCT_CLOSE);
          var closelocalOffset = b.getTimezoneOffset() * 60000;
          var closelocalTime = b.getTime() + closelocalOffset;
          if (this.selectedSeries.AUCT_OPEN !== null) {
            // this.tglbuka = this.headerService.getFormatLocalDate2(this.selectedSeries.AUCT_OPEN);
            // this.tgltutup = this.headerService.getFormatLocalDate2(this.selectedSeries.AUCT_CLOSE);
            this.tglmaturity = this.headerService.getFormatLocalDate2(this.selectedSeries.MATURITY_DATE);
            this.tglsettle = this.headerService.getFormatLocalDate2(this.selectedSeries.SETTLE_DATE);
            this.tgltutup = new Date(closelocalTime);
            this.tglbuka = new Date(openlocalTime);
          }

          if (new Date(closelocalTime).getTime() > new Date().getTime()) {
            this.openclose = 'OPEN';
          }
          else {
            this.openclose = 'CLOSE';
          };
          this.loading = false;
        } else {
          //this.toastr.warning('Sesi penawaran telah selesai');
          // this.loading = false;
        }

      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  setSeries(series) {
    // if (this.series.length > 1) {
    //   this.idx++;
    //   if (this.series.length == this.idx) {
    //     this.idx = 0;
    //   }
    //   this.selectedSeries = this.series[this.idx];
    //   if (this.selectedSeries.CD_AUCTION_TYPE == '1') {
    //     this.selectedAucType = this.auctionTypes[0];
    //   } else {
    //     this.selectedAucType = this.auctionTypes[1];
    //   }
    //   this.loading = true;
    //   this.getMapData();
    //   this.setLblAmt();
    // }
    this.selectedSeries = series;
    this.tglmaturity = this.headerService.getFormatLocalDate2(this.selectedSeries.MATURITY_DATE);
    this.tglsettle = this.headerService.getFormatLocalDate2(this.selectedSeries.SETTLE_DATE);
    // this.selectedSeries.SERIES_ID = seriesid;
    this.loading = true;
    this.getDailyBids();
    this.getMapData();
    this.setLblAmt();
  }
  setLblAmt() {
    if (this.selectedAucType.aucType == 1) {
      this.lblAmtVer = this.getLblNumber(this.selectedSeries.ISSUE_AMT_VERIFIED);
      this.lblAmtCom = this.getLblNumber(this.selectedSeries.ISSUE_AMT_COMPLETE);
      this.lblAmtUnp = this.getLblNumber(this.selectedSeries.ISSUE_AMT_UNPAID);
      this.lbltotal = this.getLblNumber(this.selectedSeries.ISSUE_AMT_COMPLETE + this.selectedSeries.ISSUE_AMT_UNPAID + this.selectedSeries.ISSUE_AMT_VERIFIED);
      this.target = this.getLblNumber(this.selectedSeries.TARGETKABEH);
      this.kuota = this.getLblNumber(this.selectedSeries.KURANGEKUOTA);
      this.minbid = this.getLblNumber(this.selectedSeries.MIN_BID);
      this.maxbid = this.getLblNumber(this.selectedSeries.MAX_BID);
      this.nomperunit = this.getLblNumber(this.selectedSeries.NOM_PER_UNIT);
      this.completedbar = this.selectedSeries.ISSUE_REAL_PCENT + '%';
      this.verifiedbar = this.selectedSeries.ISSUE_PCENT + '%';

    } else {
      this.lblAmtVer = this.getLblNumber(this.selectedSeries.AMT_VERIFIED);
      this.lblAmtCom = this.getLblNumber(this.selectedSeries.AMT_COMPLETE);
      this.lblAmtUnp = this.getLblNumber(this.selectedSeries.AMT_UNPAID);
      this.lbltotal = this.getLblNumber(this.selectedSeries.ISSUE_AMT_COMPLETE + this.selectedSeries.ISSUE_AMT_UNPAID + this.selectedSeries.ISSUE_AMT_VERIFIED);
      this.kuotaredeem = this.getLblNumber(this.selectedSeries.KUOTA_REDEEM);
      this.sisakuotaredeem = this.getLblNumber(this.selectedSeries.SISA_KUOTA_REDEEM);
      this.confirmredeem = this.getLblNumber(this.selectedSeries.KUOTA_REDEEM - this.selectedSeries.SISA_KUOTA_REDEEM);
      this.minbid = this.getLblNumber(this.selectedSeries.MIN_BID);
      this.maxbid = this.getLblNumber(this.selectedSeries.MAX_BID);
      this.nomperunit = this.getLblNumber(this.selectedSeries.NOM_PER_UNIT);
      this.completedbar = this.selectedSeries.REAL_PCENT + '%';
      this.verifiedbar = this.selectedSeries.ISSUE_PCENT + '%';
    }

  }
  getLblNumber(val: number) {
    if (val < 1000000000000 && val >= 1000000000) {
      return Math.round(val / 1000000) / 1000 + ' M';
    }
    else if (val < 1000000000 && val >= 1000000) {
      return Math.round(val / 1000) / 1000 + ' Jt';
    }
    else if (val < 1000000) {
      return Math.round(val / 1000) + ' Rb';
    }
    else {
      return Math.round(val / 1000000000) / 1000 + ' T';
    }
  }
  getMapData() {
    this.http.get(Globals.serviceUrl + 'ritel/dashmaponline?seriesId=' + this.selectedSeries.SERIES_ID + '&aucType=' + this.selectedAucType.aucType + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.dataMap = res.json();
        this.getDailyBids();
        this.setMap();
        // this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getRegionData() {
    this.http.get(Globals.serviceUrl + 'ritel/dashregiononline?seriesId=' + this.selectedSeries.SERIES_ID + '&aucType=' + this.selectedAucType.aucType + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.dataRegion = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  setAuction(e, f) {
    this.selectedAucName = e;
    this.selectedAucType.aucType = f;
    this.getSeries();
  }

  setMap() {
    let opts: any = {
      title: {
        text: 'Sebaran Data Kepemilikan ' + this.selectedSeries.SERIES_NAME
      },

      subtitle: {
        text: ''
      },
      credits: {
        enabled: false
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          verticalAlign: 'bottom',
          align: 'right'

        }
      },

      colorAxis: {
        dataClasses: [{
          from: 1000000,
          color: "#e3d8e6"
        }, {
          from: 10000000000,
          color: "#d0bad6"
        }, {
          from: 50000000000,
          color: "#bd9dc7"
        }, {
          from: 100000000000,
          color: "#a980b7"
        }, {
          from: 500000000000,
          color: "#814898"
        }, {
          from: 1000000000000,
          color: "#57007a"
        }]
      },
      legend: {
        align: 'left',
        valueDecimals: 0,
        //verticalAlign: 'bottom',
        floating: true,
        layout: 'vertical'
        //valueDecimals: 0,
        ////backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || 'rgba(255, 255, 255, 0.85)',
        //symbolRadius: 0,
        //symbolHeight: 14
      },

      series: [{
        data: this.dataMap,
        mapData: IDMap.idmap,
        joinBy: ['hc-key', 'hc_key'],
        name: 'Nominal',
        states: {
          hover: {
            color: '#004080'
          }
        },
        dataLabels: {
          enabled: true,
          format: '{point.name}'
        }
      }]
    };

    if (this.mapsEl && this.mapsEl.nativeElement) {
      opts.chart = {
        map: 'countries/id/id-all',
        renderTo: this.mapsEl.nativeElement,
        // backgroundColor: 'rgba(0,0,0,0)',
      };

      this._chart = new Highmaps.mapChart(opts);
    }

  }
  sort(val: number) {
    this.col = val;
    this.reverse = !this.reverse;
    switch (val) {
      case 1:
        this.colSort = ['COMPLETED_INVESTOR'];
        break;
      case 2:
        this.colSort = ['REGISTERED_INVESTOR'];
        break;
      case 3:
        this.colSort = ['AMT_TOTAL'];
        break;
      case 4:
        this.colSort = ['TOTAL_CITY'];
        break;
      default:
        break;
    }
  }

  sort2(val2: number) {
    this.col2 = val2;
    this.reverse2 = !this.reverse2;
    switch (val2) {
      case 1:
        this.colSort2 = ['AMT_COM'];
        break;
      case 2:
        this.colSort2 = ['AMT_VER'];
        break;
      default:
        break;
    }
  }

  scroll() {
    $('.pane-hScroll').scroll(function () {
      $('.pane-vScroll').width($('.pane-hScroll').width() + $('.pane-hScroll').scrollLeft());
    });
  }



}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/dashboard-online/dashboard-online.component.ts